const REQUIRED_MESSAGE = 'This field is required.';
const EMAIL_MESSAGE = 'Enter a valid email address.';

/**
 * @param {HTMLInputElement | HTMLTextAreaElement} input
 */
function getFieldErrorMessage(input) {
  if (!input.value.trim()) return REQUIRED_MESSAGE;
  if (input.type === 'email' && !input.checkValidity()) return EMAIL_MESSAGE;
  return '';
}

/**
 * @param {HTMLInputElement | HTMLTextAreaElement} input
 * @param {boolean} show
 */
function setFieldInvalid(input, show) {
  const message = show ? getFieldErrorMessage(input) : '';
  const errorId = input.getAttribute('aria-describedby');
  const errorEl = errorId ? document.getElementById(errorId) : null;

  input.classList.toggle('odd-contact-form__input--invalid', show && Boolean(message));
  input.setAttribute('aria-invalid', show && Boolean(message) ? 'true' : 'false');

  if (errorEl instanceof HTMLElement) {
    errorEl.textContent = message;
    errorEl.hidden = !message;
  }
}

/**
 * @param {HTMLFormElement} form
 */
function validateOddContactForm(form) {
  const fields = form.querySelectorAll('[data-odd-contact-required]');
  let valid = true;

  fields.forEach((field) => {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;
    const message = getFieldErrorMessage(field);
    setFieldInvalid(field, Boolean(message));
    if (message) valid = false;
  });

  return valid;
}

/**
 * @param {HTMLElement} wrapper
 */
function openContactSuccessDialog(wrapper) {
  const dialog = wrapper.querySelector('[data-odd-contact-success-dialog]');
  if (!(dialog instanceof HTMLDialogElement)) return;

  const closeButton = dialog.querySelector('[data-odd-contact-dialog-close]');

  const closeDialog = () => {
    if (dialog.open) dialog.close();
    if (window.location.hash.includes('ContactForm')) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  closeButton?.addEventListener('click', closeDialog, { once: true });
  dialog.addEventListener(
    'cancel',
    (event) => {
      event.preventDefault();
      closeDialog();
    },
    { once: true }
  );
  dialog.addEventListener(
    'click',
    (event) => {
      if (event.target === dialog) closeDialog();
    },
    { once: true }
  );

  dialog.showModal();
  closeButton?.focus();
}

/**
 * @param {HTMLElement} wrapper
 */
function maybeShowContactSuccessDialog(wrapper) {
  const posted =
    wrapper.dataset.oddContactSuccess === 'true' ||
    wrapper.querySelector('[data-odd-contact-success-message]') != null;

  if (posted) openContactSuccessDialog(wrapper);
}

function initOddContactForms() {
  document.querySelectorAll('.odd-contact-form').forEach((wrapper) => {
    if (!(wrapper instanceof HTMLElement)) return;

    const form = wrapper.querySelector('.odd-contact-form__form');
    if (!(form instanceof HTMLFormElement) || form.dataset.oddContactInit === 'true') return;
    form.dataset.oddContactInit = 'true';

    maybeShowContactSuccessDialog(wrapper);

    const submitButton = form.querySelector('.odd-contact-form__submit');

    form.querySelectorAll('[data-odd-contact-required]').forEach((field) => {
      if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return;

      field.addEventListener('input', () => {
        if (field.classList.contains('odd-contact-form__input--invalid')) {
          setFieldInvalid(field, Boolean(getFieldErrorMessage(field)));
        }
      });

      field.addEventListener('blur', () => {
        setFieldInvalid(field, Boolean(getFieldErrorMessage(field)));
      });
    });

    form.addEventListener('submit', (event) => {
      if (!validateOddContactForm(form)) {
        event.preventDefault();
        const firstInvalid = form.querySelector('.odd-contact-form__input--invalid');
        if (firstInvalid instanceof HTMLElement) firstInvalid.focus();
        return;
      }

      if (submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.textContent = 'Sending…';
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOddContactForms, { once: true });
} else {
  initOddContactForms();
}
